/* @flow */
import React, { Component } from 'react'

import './CommunityButtons.css'

type Props = {
  size?: string,
}

export default class CommunityButtons extends Component<Props> {

  static defultProps = {
    size: 'small',
  }

  render() {
    return (
      <div className='CommunityButtons'>
        {this.props.size !== "large" &&
          <div className="ShareButtons--share-text"><span>JOIN THE COMMUNITY <i className="icon icon-chevron-small-right"/></span></div>
        }
        <div className="social-buttons--list">
          <a className={this.props.size === "large" ? "button button-twitter" : "social-button social-button--color social-button--twitter"} href="https://www.twitter.com/NovoProtocol" target="_blank">
            <i className='icon icon-twitter' /> {this.props.size === "large" && <span className="icon-button--text">TWITTER</span>}
          </a>
          {/*
          <a className={this.props.size === "large" ? "button button-slack" : "social-button social-button--color social-button--slack"} href="http://slack.com" target="_blank">
            <i className='icon icon-slack-hash' /> {this.props.size === "large" && <span className="icon-button--text">SLACK</span>}
          </a>
          <a className={this.props.size === "large" ? "button button-telegram" : "social-button social-button--color social-button--telegram"} href="http://telegram.com" target="_blank">
            <i className='icon icon-telegram-plane' /> {this.props.size === "large" && <span className="icon-button--text">TELEGRAM</span>}
          </a>
          */}
          <a className={this.props.size === "large" ? "button button-medium-blog" : "social-button social-button--color social-button--medium-blog"}  href="https://medium.com/novoprotocol" target="_blank">
            <i className='icon icon-medium-m' /> {this.props.size === "large" && <span className="icon-button--text">LINKEDIN</span>}
          </a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Widgets/CommunityButtons/CommunityButtons.js